import React from 'react';

export default function TrashCan({ className = undefined }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 14 16"
    >
      <path d="M5.3125 1.625L4.71875 2.5H9.25L8.65625 1.625C8.625 1.5625 8.53125 1.5 8.4375 1.5H5.53125C5.4375 1.5 5.34375 1.5625 5.3125 1.625ZM9.90625 0.78125L11.0625 2.5H11.5H13H13.25C13.6562 2.5 14 2.84375 14 3.25C14 3.6875 13.6562 4 13.25 4H13V13.5C13 14.9062 11.875 16 10.5 16H3.5C2.09375 16 1 14.9062 1 13.5V4H0.75C0.3125 4 0 3.6875 0 3.25C0 2.84375 0.3125 2.5 0.75 2.5H1H2.5H2.90625L4.0625 0.78125C4.375 0.3125 4.9375 0 5.53125 0H8.4375C9.03125 0 9.59375 0.3125 9.90625 0.78125ZM2.5 4V13.5C2.5 14.0625 2.9375 14.5 3.5 14.5H10.5C11.0312 14.5 11.5 14.0625 11.5 13.5V4H2.5ZM5 6V12.5C5 12.7812 4.75 13 4.5 13C4.21875 13 4 12.7812 4 12.5V6C4 5.75 4.21875 5.5 4.5 5.5C4.75 5.5 5 5.75 5 6ZM7.5 6V12.5C7.5 12.7812 7.25 13 7 13C6.71875 13 6.5 12.7812 6.5 12.5V6C6.5 5.75 6.71875 5.5 7 5.5C7.25 5.5 7.5 5.75 7.5 6ZM10 6V12.5C10 12.7812 9.75 13 9.5 13C9.21875 13 9 12.7812 9 12.5V6C9 5.75 9.21875 5.5 9.5 5.5C9.75 5.5 10 5.75 10 6Z" />
    </svg>
  );
}
